import { Injectable } from '@angular/core';
import type * as MapboxGL from 'mapbox-gl';
import { environment } from '../../../environments/environment';

declare const mapboxgl: typeof MapboxGL & { accessToken: string };

export type Vista = 'default' | 'satelite';
export type Tema = 'light' | 'dark';

export interface OpcionesCrearMapa {
  container: HTMLElement;
  centro?: [number, number];
  zoom?: number;
  vista?: Vista;
  tema?: Tema;
}

@Injectable({ providedIn: 'root' })
export class MapboxService {
  private tokenSeteado = false;

  public crearMapa(opciones: OpcionesCrearMapa): mapboxgl.Map {
    this.asegurarToken();

    const map = new mapboxgl.Map({
      container: opciones.container,
      style: MapboxService.resolverEstilo(
        opciones.vista ?? 'default',
        opciones.tema ?? 'light',
      ),
      center: opciones.centro ?? [-58.38, -34.6],
      zoom: opciones.zoom ?? 8,
    });

    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
    map.addControl(new mapboxgl.FullscreenControl(), 'top-right');

    return map;
  }

  public static resolverEstilo(vista: Vista, _tema: Tema): string {
    if (vista === 'satelite') {
      return 'mapbox://styles/mapbox/satellite-streets-v12';
    }
    // Mapbox Standard soporta light/dark via map.setConfigProperty('basemap', 'lightPreset', 'day' | 'night')
    return 'mapbox://styles/mapbox/standard';
  }

  private asegurarToken(): void {
    if (this.tokenSeteado) return;
    const token = environment.mapboxToken;
    if (!token) {
      throw new Error(
        'mapboxToken no configurado en src/environments/environment*.ts',
      );
    }
    mapboxgl.accessToken = token;
    this.tokenSeteado = true;
  }
}
